import React from 'react'

import { withRouter } from 'react-router-dom'

import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Dialog } from 'primereact/dialog'
import { Dropdown } from 'primereact/dropdown'
import { OverlayPanel } from 'primereact/overlaypanel';
import { InputText } from 'primereact/inputtext'
import { Calendar } from 'primereact/calendar'
import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api'
import { AutoComplete } from 'primereact/autocomplete';

import NavBar from '../../componentes/Navbar'

import AtendimentoService from '../../app/service/AtendimentoService'
import LocalStorageService from '../../app/service/localStorageService'
import PessoaService from '../../app/service/PessoaService'
import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import './atendimento.css'

class Atendimentos extends React.Component{
  constructor(props) {
    super(props);

    this.atendimentoService = new AtendimentoService();
    this.pessoaService = new PessoaService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();

    this.consultarPessoa = this.consultarPessoa.bind(this);
    this.onGrupoTrabalhoChange = this.onGrupoTrabalhoChange.bind(this);
    this.acoes = this.acoes.bind(this);

    this.state = {
      atendimentos: [],
      codigoAtendimento: '',
      dtAtendimento: '',
      pessoa: null,
      pessoas: [],
      grupo: null,
      grupos: [],
      processo: null,
      processos: [],
      assunto: '',
      //Consulta de Atendimentos Filtros
      dataInicial: '',
      dataFinal: '',
      listaPessoas: [],
      selectPessoa: null,
      filterPessoas: null,
      gruposConsulta: [],
      selectGrupo: null,

    };

    addLocale('es', {
      firstDayOfWeek: 1,
      dayNames: ['Domingo', 'Domingo', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesShort: ['Domingo', 'Domingo', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Stembro', 'Outubro', 'Novembro', 'Dezemro'],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      today: 'Hoy',
      clear: 'Claro'
    });
  }

  listarPessoas = () => {
    const usuarioLogado = this.context.usuarioAutenticado
    this.pessoaService.listarPessoas(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({listaPessoas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atendimentos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarGruposTrabalho = () => {
    const usuarioLogado = this.context.usuarioAutenticado
    this.grupoTrabalhoService.listarGruposUsuario(usuarioLogado.codigo)
      .then(response => {
        this.setState({gruposConsulta: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atendimentos', detail:'Erro ao carregar Grupos de Trabalhos do usuário', life: 4000});
      });
  }

  onGrupoTrabalhoChange(e) {
    this.setState({selectGrupo: e.value})
  }

  limparCamposConsulta = () => {
    this.setState({dataInicial: ''});
    this.setState({dataFinal: ''});
    this.setState({selectGrupo: null});
    this.setState({selectPessoa: null});
  }

  consultarPessoa(event) {
    setTimeout(() => {
        let filterPessoas;
        if (!event.query.trim().length) {
            filterPessoas = [...this.state.pessoas];
        }
        else {
            filterPessoas = this.state.listaPessoas.filter((pessoa) => {
                return pessoa.nome.toLowerCase().startsWith(event.query.toLowerCase());
            });
        }

        this.setState({ filterPessoas });
    }, 250);
  }

  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  consultarAtendimentos = () => {
    const usuarioLogado = this.context.usuarioAutenticado
    
    let pessoa = '0';
    if(this.state.selectPessoa != null) {
      pessoa = this.state.selectPessoa[0].codigo;
    }

    let grupo = '0';
    if(this.state.selectGrupo!= null) {
      grupo = this.state.selectGrupo.codigo;
    }

    //Data Inicial
    var dataFormatadaInicial = '';
    if(this.state.dataInicial != '') {
      var date = this.state.dataInicial;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaInicial =  year+"-"+month+"-"+day;
    }

    //Data final
    var dataFormatadaFinal = '';
    if(this.state.dataFinal != '') {
      var date = this.state.dataFinal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaFinal =  year+"-"+month+"-"+day;
    }

    this.atendimentoService.consultarAtendimentos(usuarioLogado.empresa.codigo,
      dataFormatadaInicial, dataFormatadaFinal, pessoa, grupo)
      .then(response => {
        this.setState({atendimentos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atendimentos', detail:`${this.state.detail}`, life: 4000});
      });

      this.op.hide();
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-comments" className="p-button-rounded p-button-text" 
                tooltip="Abrir registros de atendimento"
                onClick={() => this.consultarAtendimento(rowData)}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  consultarAtendimento(atendimento) {
    this.props.history.push(`/historicoAtendimento/${atendimento.codigo}/atendimento/${atendimento.pessoa.codigo}`)      
  }

  novoAtendimento =() => {
    this.props.history.push('/novoAtendimento')
  }

  async componentDidMount() {
    await this.consultarAtendimentos();
    this.listarPessoas();
    this.listarGruposTrabalho();
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="pi pi-comments"></i>
                        <span> Atendimentos</span>
                      </h3>  
                    </div>

                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5">
                          <span className="input-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                      onClick={this.novoAtendimento} 
                                      aria-haspopup aria-controls="overlay_panel">
                              <i className="fas fa-plus"></i> Adicionar</button>
                              &nbsp;
                              <button type="button" className="btn btn-info bg-gradient-info" 
                                      data-toggle="modal" 
                                      title="Consultar"
                                      onClick={(e) => this.op.toggle(e)} 
                                      aria-haspopup aria-controls="overlay_panel">
                              <i className="fas fa-filter"></i></button>

                              <OverlayPanel ref={(el) => this.op = el} showCloseIcon id="overlay_panel" 
                                            onShow={this.carregaCombosConsulta}
                                            className="overlaypanel-demo"
                                            onShow={this.limparCamposConsulta}>

                                <div className="row">
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <label>Dt. Atendimento</label>
                                      <Calendar id="dtPesquisa1" 
                                                value={this.state.dataInicial} 
                                                onChange={(e) => this.setState({ dataInicial: e.value })} 
                                                locale="es"
                                                style={{width: '100%', height: '37px'}} 
                                                dateFormat="dd/mm/yy"
                                                mask="99/99/9999"/>
                                    </div>
                                  </div>
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <label>&nbsp;</label>
                                      <Calendar id="dtPesquisa2" 
                                                value={this.state.dataFinal} 
                                                onChange={(e) => this.setState({ dataFinal: e.value })} 
                                                locale="es"
                                                style={{width: '100%', height: '37px'}} 
                                                dateFormat="dd/mm/yy"
                                                mask="99/99/9999"/>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-sm-10">
                                    <div className="form-group">
                                    <label>Pessoa</label>
                                    <AutoComplete value={this.state.selectPessoa} 
                                                  suggestions={this.state.filterPessoas} 
                                                  completeMethod={this.consultarPessoa}
                                                  style={{width: '207%', height: '37px'}} 
                                                  field="nome" multiple
                                                  onChange={(e) => this.setState({selectPessoa: e.value })} 
                                                  className="p-autoComplete-sm p-d-block p-mb-0"/>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-sm-12">
                                    <div className="form-group">
                                    <label>Grupo de Assuntos</label>
                                    <Dropdown value={this.state.selectGrupo} 
                                              options={this.state.gruposConsulta} style={{width: '100%', height: '37px'}}
                                              optionLabel="nome" 
                                              filter showClear filterBy="nome"
                                              onChange={this.onGrupoTrabalhoChange}
                                              id="grupoTrabalho"
                                              className="p-inputtext-sm p-d-block p-mb-1"/>
                                    </div>
                                  </div>
                                </div>
                                <div className="direita">
                                  <button type="submit" className="btn btn-success" onClick={this.consultarAtendimentos}>
                                    <i className="fas fa-check"></i>
                                    &nbsp;Consultar
                                  </button>
                                </div>
                              </OverlayPanel>
                          </span>
                        </div>
                      </div>
                    </div>
                    <DataTable value={this.state.atendimentos}  paginator responsiveLayout="scroll"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10} emptyMessage=" "
                        selectionMode="multiple">
                        <Column field="pessoa.nome" header="Pessoa"></Column>
                        <Column field="grupo.nome" header="Grupo de Assuntos"></Column>
                        <Column field="assunto" header="Assunto"></Column>
                        <Column field="dtAtendimento" header="Dt. Atendimento"></Column>
                        <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    )
  }
}
Atendimentos.contextType = AuthContext;
export default withRouter(Atendimentos)
